import React from 'react';
import MaterialTable from 'material-table';
import MaterialTablePagination from './MaterialTablePagination';
import MaterialTableOverlayLoading from './MaterialTableOverlayLoading';

/**
 * Wrapper around MaterialTable that fixes Material-UI deprecation warnings
 * by automatically including the fixed Pagination and OverlayLoading components
 */
const MaterialTableFixed = (props) => {
  const { components = {}, ...otherProps } = props;

  return (
    <MaterialTable
      {...otherProps}
      components={{
        ...components,
        Pagination: components.Pagination || MaterialTablePagination,
        OverlayLoading: components.OverlayLoading || MaterialTableOverlayLoading,
      }}
    />
  );
};

export default MaterialTableFixed;

